import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CompareResult } from '../data/convertCompareCount';

const initialState: CompareResult | null = null;

const comparisonResultsSlice = createSlice({
  name: 'comparisonResults',
  initialState: initialState as CompareResult | null,
  reducers: {
    setComparisonResults: (state, action: PayloadAction<CompareResult>) => action.payload,
  },
});

export const { setComparisonResults } = comparisonResultsSlice.actions;
export const comparisonResults = comparisonResultsSlice.reducer;
